module.exports = __webpack_public_path__ + "img/full7-min.47eaf8e3.png";